"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-monitor/user-credit-data.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-monitor%2Fuser-credit-data.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.scoreStatusToJSON = exports.scoreStatusFromJSON = exports.UserCreditMonitoringState = exports.CreditScore = exports.UserCreditScoreData = exports.UserCreditData = exports.ScoreStatus = void 0;
const credit_bureau_1 = require("../common/credit-bureau");
const date_1 = require("../common/date");
const migration_1 = require("./migration");
const score_factors_1 = require("./score-factors");
const score_model_1 = require("./score-model");
const protobufPackage = 'com.step.creditmonitor.proto';
var ScoreStatus;
(function (ScoreStatus) {
    ScoreStatus["INVALID_NO_SCORE_REASON"] = "INVALID_NO_SCORE_REASON";
    /**
     * SCORE_AVAILABLE - The score is available.
     */
    ScoreStatus["SCORE_AVAILABLE"] = "SCORE_AVAILABLE";
    /**
     * PULL_NOT_ATTEMPTED - Score is not available, a credit pull has not been attempted yet.
     */
    ScoreStatus["PULL_NOT_ATTEMPTED"] = "PULL_NOT_ATTEMPTED";
    /**
     * SCORE_NOT_AVAILABLE - Score is not available due to a no hit or thin file. This is more likely to
     * happen for new entrants to the credit system. May require contacting support
     * depending on the user's situation.
     */
    ScoreStatus["SCORE_NOT_AVAILABLE"] = "SCORE_NOT_AVAILABLE";
    /**
     * SCORE_NOT_AVAILABLE_TERMINAL - Score not available for other reasons. This is a terminal state and likely
     * requires contacting support and updating PII information.
     */
    ScoreStatus["SCORE_NOT_AVAILABLE_TERMINAL"] = "SCORE_NOT_AVAILABLE_TERMINAL";
    ScoreStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ScoreStatus || (exports.ScoreStatus = ScoreStatus = {}));
function createBaseUserCreditData() {
    return { creditScoreData: undefined, creditMonitoringState: undefined };
}
exports.UserCreditData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.creditScoreData)) {
            message.creditScoreData = exports.UserCreditScoreData.fromJSON(object.creditScoreData);
        }
        if (isSet(object.creditMonitoringState)) {
            message.creditMonitoringState = exports.UserCreditMonitoringState.fromJSON(object.creditMonitoringState);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditScoreData !== undefined) {
            obj.creditScoreData = exports.UserCreditScoreData.toJSON(message.creditScoreData);
        }
        if (message.creditMonitoringState !== undefined) {
            obj.creditMonitoringState = exports.UserCreditMonitoringState.toJSON(message.creditMonitoringState);
        }
        return obj;
    },
    create(base) {
        return exports.UserCreditData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserCreditData();
        message.creditScoreData =
            (object.creditScoreData !== undefined && object.creditScoreData !== null)
                ? exports.UserCreditScoreData.fromPartial(object.creditScoreData)
                : undefined;
        message.creditMonitoringState =
            (object.creditMonitoringState !== undefined && object.creditMonitoringState !== null)
                ? exports.UserCreditMonitoringState.fromPartial(object.creditMonitoringState)
                : undefined;
        return message;
    },
};
function createBaseUserCreditScoreData() {
    return {
        bureau: credit_bureau_1.CreditBureau.INVALID_CREDIT_BUREAU,
        scoreModel: score_model_1.ScoreModel.INVALID_SCORE_MODEL,
        scoreHistory: [],
        latestScoreFactors: undefined,
    };
}
exports.UserCreditScoreData = {
    fromJSON(object) {
        const message = {
            bureau: isSet(object.bureau)
                ? (0, credit_bureau_1.creditBureauFromJSON)(object.bureau)
                : credit_bureau_1.CreditBureau.INVALID_CREDIT_BUREAU,
            scoreModel: isSet(object.scoreModel)
                ? (0, score_model_1.scoreModelFromJSON)(object.scoreModel)
                : score_model_1.ScoreModel.INVALID_SCORE_MODEL,
        };
        if (globalThis.Array.isArray(object?.scoreHistory)) {
            message.scoreHistory = object.scoreHistory.map((e) => exports.CreditScore.fromJSON(e));
        }
        if (isSet(object.latestScoreFactors)) {
            message.latestScoreFactors = score_factors_1.ScoreFactors.fromJSON(object.latestScoreFactors);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bureau !== credit_bureau_1.CreditBureau.INVALID_CREDIT_BUREAU) {
            obj.bureau = (0, credit_bureau_1.creditBureauToJSON)(message.bureau);
        }
        if (message.scoreModel !== score_model_1.ScoreModel.INVALID_SCORE_MODEL) {
            obj.scoreModel = (0, score_model_1.scoreModelToJSON)(message.scoreModel);
        }
        if (message.scoreHistory?.length) {
            obj.scoreHistory = message.scoreHistory.map((e) => exports.CreditScore.toJSON(e));
        }
        if (message.latestScoreFactors !== undefined) {
            obj.latestScoreFactors = score_factors_1.ScoreFactors.toJSON(message.latestScoreFactors);
        }
        return obj;
    },
    create(base) {
        return exports.UserCreditScoreData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserCreditScoreData();
        message.bureau = object.bureau ?? credit_bureau_1.CreditBureau.INVALID_CREDIT_BUREAU;
        message.scoreModel = object.scoreModel ?? score_model_1.ScoreModel.INVALID_SCORE_MODEL;
        message.scoreHistory = object.scoreHistory?.map((e) => exports.CreditScore.fromPartial(e)) || [];
        message.latestScoreFactors =
            (object.latestScoreFactors !== undefined && object.latestScoreFactors !== null)
                ? score_factors_1.ScoreFactors.fromPartial(object.latestScoreFactors)
                : undefined;
        return message;
    },
};
function createBaseCreditScore() {
    return { referenceId: '', score: 0, date: date_1.LocalDate.fromPartial({}) };
}
exports.CreditScore = {
    fromJSON(object) {
        const message = {
            referenceId: isSet(object.referenceId) ? globalThis.String(object.referenceId) : '',
            score: isSet(object.score) ? globalThis.Number(object.score) : 0,
            date: isSet(object.date) ? date_1.LocalDate.fromJSON(object.date) : date_1.LocalDate.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.score !== 0) {
            obj.score = Math.round(message.score);
        }
        if (message.date !== undefined) {
            obj.date = date_1.LocalDate.toJSON(message.date);
        }
        return obj;
    },
    create(base) {
        return exports.CreditScore.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditScore();
        message.referenceId = object.referenceId ?? '';
        message.score = object.score ?? 0;
        message.date = (object.date !== undefined && object.date !== null)
            ? date_1.LocalDate.fromPartial(object.date)
            : date_1.LocalDate.fromPartial({});
        return message;
    },
};
function createBaseUserCreditMonitoringState() {
    return {
        firstScoreStatus: ScoreStatus.INVALID_NO_SCORE_REASON,
        isEnrolled: false,
        migrationContext: undefined,
    };
}
exports.UserCreditMonitoringState = {
    fromJSON(object) {
        const message = {
            firstScoreStatus: isSet(object.firstScoreStatus)
                ? scoreStatusFromJSON(object.firstScoreStatus)
                : ScoreStatus.INVALID_NO_SCORE_REASON,
            isEnrolled: isSet(object.isEnrolled) ? globalThis.Boolean(object.isEnrolled) : false,
        };
        if (isSet(object.migrationContext)) {
            message.migrationContext = migration_1.MigrationContext.fromJSON(object.migrationContext);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.firstScoreStatus !== ScoreStatus.INVALID_NO_SCORE_REASON) {
            obj.firstScoreStatus = scoreStatusToJSON(message.firstScoreStatus);
        }
        if (message.isEnrolled !== false) {
            obj.isEnrolled = message.isEnrolled;
        }
        if (message.migrationContext !== undefined) {
            obj.migrationContext = migration_1.MigrationContext.toJSON(message.migrationContext);
        }
        return obj;
    },
    create(base) {
        return exports.UserCreditMonitoringState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserCreditMonitoringState();
        message.firstScoreStatus = object.firstScoreStatus ?? ScoreStatus.INVALID_NO_SCORE_REASON;
        message.isEnrolled = object.isEnrolled ?? false;
        message.migrationContext =
            (object.migrationContext !== undefined && object.migrationContext !== null)
                ? migration_1.MigrationContext.fromPartial(object.migrationContext)
                : undefined;
        return message;
    },
};
function scoreStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_NO_SCORE_REASON':
            return ScoreStatus.INVALID_NO_SCORE_REASON;
        case 1:
        case 'SCORE_AVAILABLE':
            return ScoreStatus.SCORE_AVAILABLE;
        case 2:
        case 'PULL_NOT_ATTEMPTED':
            return ScoreStatus.PULL_NOT_ATTEMPTED;
        case 3:
        case 'SCORE_NOT_AVAILABLE':
            return ScoreStatus.SCORE_NOT_AVAILABLE;
        case 4:
        case 'SCORE_NOT_AVAILABLE_TERMINAL':
            return ScoreStatus.SCORE_NOT_AVAILABLE_TERMINAL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ScoreStatus.UNRECOGNIZED;
    }
}
exports.scoreStatusFromJSON = scoreStatusFromJSON;
function scoreStatusToJSON(object) {
    switch (object) {
        case ScoreStatus.INVALID_NO_SCORE_REASON:
            return 'INVALID_NO_SCORE_REASON';
        case ScoreStatus.SCORE_AVAILABLE:
            return 'SCORE_AVAILABLE';
        case ScoreStatus.PULL_NOT_ATTEMPTED:
            return 'PULL_NOT_ATTEMPTED';
        case ScoreStatus.SCORE_NOT_AVAILABLE:
            return 'SCORE_NOT_AVAILABLE';
        case ScoreStatus.SCORE_NOT_AVAILABLE_TERMINAL:
            return 'SCORE_NOT_AVAILABLE_TERMINAL';
        case ScoreStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.scoreStatusToJSON = scoreStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=user-credit-data.js.map